import React, { useState } from 'react';
import { useTranslation } from "react-i18next";
import Axios from "../../Axios";
import AreYouSure, { AYSButton } from '../AreYouSure.tsx';

const Navbar = ({ page }) => {

    const { t } = useTranslation();
    let selected = page ? page : 'Home';

    const [ showAlert, setAlert ] = useState();
    const token = sessionStorage.getItem('token');

    const signout = async () => {
        try {
            const response = await Axios.post('/api/auth/sign-out', {}, {
                headers: {
                    "Content-Type": "application/json",
                    "auth-token": token
                },
                withCredentials: true
            });

            if (response.status === 204) {
                alert(t("Sign out successful"));
                sessionStorage.removeItem('token');
                window.location.href = "/login";
            } else if (response.status === 500) {
                setAlert( 
                    <AreYouSure
                        title = { t( 'Warning' ) }
                        message = { response.data }
                        buttons={[
                                  <AYSButton
                                    text = { t( 'Ok' ) }
                                    callback = { e => setAlert( undefined ) }
                                    type = "cancel"
                                  /> ] }
                        callback = { res => {
                            setAlert( undefined )
                            return null;
                        } }
                    />)
            } else {
                setAlert( 
                    <AreYouSure
                        title = { t( 'Warning' ) }
                        message = { t( 'Sign out failed' ) }
                        buttons={[
                                  <AYSButton
                                    text = { t( 'Ok' ) }
                                    callback = { e => setAlert( undefined ) }
                                    type = "cancel"
                                  /> ] }
                        callback = { res => {
                            setAlert( undefined )
                            return null;
                        } }
                    />)
            }
        } catch (error) {
            console.error("Error during sign out:", error);
        }
    }

    return (
        <>
        <nav className="bg-blue-500 p-1 shadow-md flex justify-between items-center relative z-10">
            <img className="w-100 h-10 ml-2" src="/svg/FLEXI_PROCESS/Pack_white/logo_text_superpose.png"
                alt="logo" />
            <div className="flex space-x-6">
                {['Home', 'Planning', "Timeline", 'Image', 'Chart', "Management"].map((path) => (
                    <button
                        className={`text-lg ${selected === path ? 'text-gray-700' : 'text-white'} hover:text-gray-700`}
                        key={path}
                        onClick={() => { window.location.href = `/${path.toLocaleLowerCase()}` }}
                    >
                        {t(path)}
                    </button>
                ))}

                <button
                    className={`inline-flex items-center justify-center p-2 ml-10 w-10 h-10 text-lg ${selected === "Settings" ? 'text-gray-700' : 'text-white'} hover:text-gray-700`}
                    key={"Settings"}
                    onClick={() => { window.location.href = `/settings` }}
                >

                    <span className="sr-only">{t("settings")}</span>
                    <svg version="1.1" viewBox="0 0 256 256" xmlns="http://www.w3.org/2000/svg">
                        <g transform="translate(1.4066 1.4066) scale(2.81)" fill="none">
                            <path
                                d="m82.3 32.54c-2.685 0-5.092-1.544-6.326-3.929-0.246-0.475-0.504-0.948-0.774-1.416s-0.55-0.928-0.839-1.378c-1.448-2.26-1.582-5.118-0.24-7.443 1.95-3.377 0.793-7.695-2.584-9.645l-9.353-5.4c-3.377-1.95-7.695-0.793-9.645 2.584l-2e-3 3e-3c-1.323 2.291-3.814 3.641-6.456 3.512-1.148-0.056-2.301-0.056-3.455 0-2.637 0.128-5.123-1.226-6.443-3.513l-1e-3 -2e-3c-1.95-3.377-6.268-4.534-9.645-2.584l-9.353 5.4c-3.377 1.95-4.534 6.268-2.584 9.645l1e-3 2e-3c1.32 2.286 1.25 5.116-0.179 7.336-0.625 0.971-1.202 1.97-1.727 2.992-1.209 2.353-3.624 3.835-6.27 3.835h0.636c-3.9 0-7.061 3.162-7.061 7.061v10.8c0 3.9 3.161 7.061 7.061 7.061v0c2.685 0 5.092 1.544 6.326 3.929 0.246 0.475 0.504 0.947 0.774 1.416 0.27 0.468 0.55 0.928 0.839 1.378 1.448 2.26 1.582 5.118 0.24 7.442-1.95 3.377-0.793 7.696 2.584 9.645l9.353 5.4c3.377 1.95 7.695 0.793 9.645-2.584l2e-3 -3e-3c1.323-2.291 3.814-3.641 6.456-3.512 1.148 0.056 2.301 0.057 3.455 1e-3 2.637-0.128 5.123 1.226 6.443 3.513l1e-3 2e-3c1.95 3.377 6.268 4.534 9.645 2.584l9.353-5.4c3.377-1.95 4.534-6.268 2.584-9.645l-1e-3 -2e-3c-1.32-2.286-1.25-5.116 0.179-7.336 0.625-0.971 1.201-1.97 1.727-2.992 1.209-2.353 3.624-3.835 6.27-3.835h4e-3c3.9 0 7.061-3.161 7.061-7.061v-10.801c-1e-3 -3.899-3.162-7.06-7.062-7.06zm-27.302 29.778c-9.564 5.522-21.794 2.245-27.316-7.319s-2.245-21.794 7.319-27.316 21.794-2.245 27.316 7.319c5.523 9.564 2.246 21.794-7.319 27.316z"
                                stroke="currentColor"
                                fill="currentColor"
                            />
                        </g>
                    </svg>
                </button>
            </div>
            <button
                onClick={signout}
                className="text-white text-sm flex bg-white-500/50 border border-gray-300/50 px-2 py-1 rounded-lg hover:bg-red-500 mr-2"
            >
                <div className='h-5 flex place-items-center'>
                    <img className="w-4 h-4 mr-1" src="/svg/settings.svg" alt="signout" />
                </div>
                <p className=' h-5 -mt-px'>{t('log out')}</p>
            </button>
        </nav>
        { showAlert }
        </>
    );
};

export default Navbar;
